<template>
  <div>
    <el-table
      :data="userList"
      style="width: 100%"
      height="calc(100vh - 360px)"
      ref="myTable"
    >
      <!-- <el-table-column label="合伙人账户" width="160" fixed="left">
        <template slot-scope="scope">{{ scope.row.accountName }}</template>
      </el-table-column> -->
      <!-- <el-table-column prop="createTime" label="返佣日期" align="center" fixed="left">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="channelUserId" label="合伙人UID" align="center" fixed="left" width="120">
        <template slot-scope="scope">
          <span>{{ scope.row.channelUserId }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="totalFee" label="OTC出金量(USDT)" align="center" width="140">
        <template slot-scope="scope">
          <span>{{ scope.row.totalFee }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rate" label="OTC返佣比例（%）" align="center" >
        <template slot-scope="scope">
          <span>{{ scope.row.rate*100 }}%</span>
        </template>
      </el-table-column>
     
      <el-table-column prop="shouldRebateAmount" label="系统计算OTC返佣(USDT)" align="center" width="230">
        <template slot-scope="scope">
          <span>{{ scope.row.shouldRebateAmount }}</span>
         
        </template>
      </el-table-column>
      <el-table-column prop="realityRebateAmount" label="实际发放返佣(USDT)" align="center" width="230">
        <template slot-scope="scope">
          {{ scope.row.realityRebateAmount }}
        </template>
      </el-table-column>
      
      <el-table-column prop="status" label="审核状态" align="center" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.status==1">拒绝</span>
          <span v-if="scope.row.status==0">通过</span>
          <span v-if="scope.row.status==5">未审核</span>
        </template>
      </el-table-column> -->
      <el-table-column prop="tenantName" label="租户名称" align="center" />
      <el-table-column
        property="channelUserId"
        label="合伙人UID"
        width="90"
      ></el-table-column>
      <el-table-column
        property="remark"
        label="备注"
        width="90"
      ></el-table-column>
      <el-table-column property="rate" label="返佣比例" width="90">
        <template slot-scope="scope">
          {{ BigNumber(scope.row.rate * 100) }}%
        </template>
      </el-table-column>
      <el-table-column
        property="totalFee"
        label="手续费"
        width="120"
      ></el-table-column>
      <!-- <el-table-column property="otcRate" label="otc出金返佣比例" width="90"></el-table-column> -->
      <el-table-column
        property="shouldRebateAmount"
        label="合伙人返佣金额"
        width="120"
      ></el-table-column>
      <el-table-column
        property="realityRebateAmount"
        label="发放金额"
        width="90"
      ></el-table-column>
      <el-table-column
        property="selfRebateAmount"
        label="合伙人合约返佣金额"
        width="120"
      ></el-table-column>
      <!-- <el-table-column property="selfOtcRebateAmount" label="合伙人otc出金返佣金额" width="120"></el-table-column> -->
      <el-table-column
        property="teamRebateAmount"
        label="团队返佣金额"
        width="120"
      ></el-table-column>

      <el-table-column
        property="selfTeamRebateAmount"
        label="合伙人团队合约返佣金额"
        width="120"
      ></el-table-column>
      <!-- <el-table-column property="selfTeamOtcRebateAmount" label="合伙人团队otc出金返佣金额" width="160"></el-table-column> -->

      <el-table-column
        property="teamTotalHistoryRebateAmount"
        label="团队历史返佣总额"
        width="120"
      ></el-table-column>
      <el-table-column
        property="selfSpotRebateAmount"
        label="合伙人现货返佣金额"
        width="190"
      >
        <template slot-scope="scope">
          {{ scope.row.selfSpotRebateAmount || 0 }}
        </template>
      </el-table-column>
      <el-table-column
        property="selfTeamSpotRebateAmount"
        label="合伙人现货团队返佣金额"
        width="190"
      >
        <template slot-scope="scope">
          {{ scope.row.selfTeamSpotRebateAmount || 0 }}
        </template>
      </el-table-column>
      <el-table-column property="createTime" label="返佣日期" width="160">
        <!-- <template slot-scope="scope">
        <div>
          {{ isoToFormat(scope.row.createTime) }}
        </div>
      </template> -->
      </el-table-column>
      <el-table-column label="发放状态" width="140">
        <template slot-scope="scope">
          <div>
            <el-tag type="success" v-if="scope.row.grantTime">已发放</el-tag>
            <el-tag v-else>未发放</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        label="审核状态"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.status == 1">拒绝</span>
          <span v-if="scope.row.status == 0">通过</span>
          <span v-if="scope.row.status == 5">未审核</span>
        </template>
      </el-table-column>
      <el-table-column property="grantTime" label="发放时间" width="160">
        <!-- <template slot-scope="scope">
        <div>
          {{ isoToFormat(scope.row.grantTime) }}
        </div>
      </template> -->
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <!-- {{isToday(scope.row.createTime)}} --> <!-- 之前只能审核当天的 -->
          <div v-if="scope.row.type ==1">
           
            <!--<div v-if="scope.row.rebateStatus == 0">-->
            <el-button
              size="mini"
              type="text"
              @click="handleUpdate(scope.row, 0)"
              >通过</el-button
            >
            <el-button
              size="mini"
              type="text"
              @click="handleUpdatePartner(scope.row, 1)"
              >拒绝</el-button
            >
          </div>

          <!-- <el-button
            size="mini"
            type="text"
            @click="handleRate(scope.row, 1)"
            v-if="scope.row.rebateRate != 0 && scope.row.type == 0"
            >设置返佣比例</el-button
          > -->
        </template>
      </el-table-column>
    </el-table>
    <div class="pag">
      <pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="pageChanged"
      ></pagination>
    </div>
    <!-- <update-dialog :val="userinfoDetail" :updateForm="updateForm"></update-dialog> -->

    <!-- 编辑用户信息dialog -->
    <el-dialog
      title="修改备注"
      :visible.sync="centerDialogVisible"
      width="30%"
      center
    >
      <div class="main">
        <el-card class="box-card">
          <div>备注信息</div>
          <div class="content">
            <el-input
              type="textarea"
              :rows="5"
              placeholder="请输入备注信息"
              maxlength="50"
              show-word-limit
              v-model="textarea2"
            >
            </el-input>
          </div>
          <div class="btn">
            <el-button size="small" type="primary" @click="add"
              >添 加</el-button
            >
          </div>
        </el-card>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
    <!-- 升级合伙人 -->
    <el-dialog
      :title="title"
      :visible.sync="partnerDialogVisible"
      width="30%"
      center
    >
      <div class="main">
        <el-card class="box-card box-card1">
          <div class="content">
            <el-form label-width="50px">
              <el-form-item label="比例 :">
                <el-input
                  type="number"
                  placeholder="请输入返佣比例"
                  v-model="input2"
                >
                  <template slot="append">%</template>
                </el-input>
                <div class="tip">
                  <span>
                    <i class="el-icon-warning-outline"></i>
                    说明:返佣比例一旦设定,只支持提高,不支持降低
                  </span>
                </div>
              </el-form-item>
            </el-form>
          </div>
          <div class="btn">
            <el-button size="small" @click="partnerDialogVisible = false"
              >取 消</el-button
            >
            <el-button size="small" type="primary" @click="addRate"
              >确 定</el-button
            >
          </div>
        </el-card>
      </div>
      <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="centerDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="centerDialogVisible = false">确 定</el-button>
  </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import Pagination from 'components/pagination'
import updateDialog from '../updatedialog'
import moment from 'moment'
export default {
  name: 'rebateReviewList',
  data() {
    return {
      updateForm: {},
      updateUserTypeDialogVisible: false,
      newUserType: '',
      selectedForUserType: {},
      textarea2: '',
      centerDialogVisible: false,
      partnerDialogVisible: false,
      input2: '',
      upgradeRateForm: {},
      title: '',
    }
  },
  components: {
    Pagination,
    updateDialog,
  },
  methods: {
    ...mapActions('user', ['addRemark']),
    ...mapActions('rebateReview', [
      'upgradePartner',
      'upgradeRate',
      'auditing',
    ]),
    ...mapMutations('rebateReview', [
      'setUserinfoDetailDialogVisible',
      'setUserinfoDetail',
    ]),
    isoToFormat(isoDate) {
      if (!isoDate) {
        return ''
      }
      const date = new Date(isoDate)
      const utc = date.getTime() + date.getTimezoneOffset() * 60000
      const local = new Date(utc)
      const year = local.getFullYear()
      const month = String(local.getMonth() + 1).padStart(2, '0')
      const day = String(local.getDate()).padStart(2, '0')
      const hour = String(local.getHours()).padStart(2, '0')
      const minute = String(local.getMinutes()).padStart(2, '0')
      const second = String(local.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    },
    add() {
      this.addRemark({
        channelId: this.userInfo.channelId,
        userId: this.updateForm.id,
        remarks: this.textarea2,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success('添加成功')
          ;(this.textarea2 = ''), (this.centerDialogVisible = false)
          this.$emit('refresh')
        }
      })
    },
    addRate() {
      if (this.btnType == 0) {
        this.upgradePartner({
          channelId: this.userInfo.channelId,
          userId: this.upgradeRateForm.id,
          rate: Number(this.input2),
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('申请合伙人成功')
            this.partnerDialogVisible = false
            this.input2 = ''
            this.$emit('refresh')
          } else {
            this.$message.error(res.error.msg)
          }
        })
      }
      if (this.btnType == 1) {
        this.upgradeRate({
          channelId: this.userInfo.channelId,
          userId: this.upgradeRateForm.id,
          rate: Number(this.input2),
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('设置返佣比例成功')
            this.partnerDialogVisible = false
            this.input2 = ''
            this.$emit('refresh')
          } else {
            this.$message.error(res.error.msg)
          }
        })
      }
    },
    pageChanged(pagination) {
      this.$emit('refresh', pagination)
    },
    handleUpdate(row, status) {
      this.$confirm('确定通过审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          console.log('rrrrrrrrrrrr', row.id, row.status)
          this.auditing({ rebateId: row.id, status }).then((res) => {
            if (res.code == 0) {
              if (res.data.code == 0) {
                this.$emit('refresh', this.pagination)
                this.$message({
                  type: 'success',
                  message: '已通过审核!',
                })
              } else {
                this.$message.warning(res.data.msg || '审核失败')
              }
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    handleUpdatePartner(row, status) {
      // this.title='升级合伙人'
      // this.upgradeRateForm = { ...row };
      // this.partnerDialogVisible = true;
      // this.btnType = type;
      this.$confirm('拒绝通过审核?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.auditing({ rebateId: row.id, status }).then((res) => {
            if (res.code == 0) {
              if (res.data.code == 0) {
                this.$emit('refresh', this.pagination)
                this.$message({
                  type: 'success',
                  message: '已拒绝通过审核!',
                })
              } else {
                this.$message.warning(res.data.msg || '审核失败')
              }
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    handleRate(row, type) {
      this.title = '设置返佣比例'
      this.partnerDialogVisible = true
      this.upgradeRateForm = { ...row }
      this.input2 = row.rebateRate * 100
      this.btnType = type
    },
    // isToday(time) {
    //   // 获取今天的开始时间和结束时间
    //   const todayStart = new Date()
    //   todayStart.setHours(0, 0, 0, 0)
    //   const todayEnd = new Date(todayStart)
    //   todayEnd.setHours(23, 59, 59, 999)

    //   // 检查输入的时间是否在今天的开始时间和结束时间之间
    //   return (
    //     new Date(time).getTime() - 8 * 60 * 60 * 1000 >= todayStart &&
    //     new Date(time).getTime() - 8 * 60 * 60 * 1000 <= todayEnd
    //   )
    // },

    isToday(time) {
      // 当天的12点半之后才能审核当天之前的数据
      // 设置今天的0点30分
      const todayStart = new Date()
      todayStart.setHours(0, 30, 0, 0)
      // 获取当前时间
      const currentTime = new Date().getTime()
      const res = todayStart.getTime() - 24 * 60 * 60 * 1000

      // 检查输入的时间是否在今天的0点30分之前
      return (
        new Date(time).getTime() - 8 * 60 * 60 * 1000 <= res &&
        currentTime > todayStart.getTime()
      )
    },
  },
  computed: {
    // ...mapGetters('user', ['userList']),
    ...mapState(['userInfo']),
    ...mapState('rebateReview', [
      'pagination',
      'userList',
      'totalCount',
      'userinfoDetail',
      'userinfoDetailDialogVisible',
    ]),
  },
  mounted() {
    this.$refs.myTable && this.$refs.myTable.doLayout()
  },
}
</script>

<style lang="less" src="../../../../styles/table.less" scoped>
.pag {
  display: flex;
  justify-content: center;
}
.user-type-select {
  width: 100%;
}
</style>
